import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import UsersService from '~/api/services/users'
import Layout from '~/components/Layout'
import { UserProfileLogo, StyledDefaultProfile, StyledSegment } from './style'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { StyledGridColumns, StyledGridRow } from '~/pages/Dairy/MilkFixedPrice/ShowMilkFixedPrice/style'
import { Divider, Grid, Icon } from 'semantic-ui-react'
import { handleErrors } from '~/utils/helpers'

const Show: React.FC = () => {
  const [isBusy, setIsBusy] = useState(false)
  const [showData, setShowData] = useState(null)
  const { id } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()

  useEffect(() => {
    fetchShowData()
  }, [])

  async function fetchShowData() {
    setIsBusy(true)
    try {
      const response = await UsersService.showUser(id)
      const responsePhoto = await UsersService.getUserFile(id)
      setShowData({
        ...response.data,
        photoUrl: responsePhoto.data
      })
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderProfileDetails() {
    return <StyledSegment placeholder>
      <Grid columns={2} stackable>
        <Divider vertical />
        <Grid.Row verticalAlign='middle'>
          <Grid.Column>
            <Grid columns={4} stackable>
              <StyledGridRow>
                <Grid.Column>{t('Verified')}</Grid.Column>
                <StyledGridColumns>
                  <Icon name={showData?.verified === 0 ? 'remove circle' : 'check circle'} color={showData?.verified === 0 ? 'red' : 'green'} />
                </StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Full name')}</Grid.Column>
                <StyledGridColumns>{showData?.name}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Email')}</Grid.Column>
                <StyledGridColumns>{showData?.email}</StyledGridColumns>
              </StyledGridRow>
            </Grid>
          </Grid.Column>
          <Grid.Column>
            <Grid columns={4} stackable>
              <StyledGridRow>
                <Grid.Column>{t('Phone number')}</Grid.Column>
                <StyledGridColumns>{showData?.phonePrefixCountry ? `${showData?.phonePrefixCountry} ${showData?.phonePrefix} ${showData?.phoneNumber}` : '-'}</StyledGridColumns>
              </StyledGridRow>
              <StyledGridRow>
                <Grid.Column>{t('Mobile number')}</Grid.Column>
                <StyledGridColumns>{`${showData?.mobilePrefixCountryPhoneCode} ${showData?.mobilePrefix} ${showData?.mobileNumber}`}</StyledGridColumns>
              </StyledGridRow>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </StyledSegment>
  }

  function renderDefaultImage() {
    return <StyledDefaultProfile color='blue' name='user circle' size='big' />
  }

  function renderImage() {
    return <LazyLoadImage
      alt={''}
      effect='blur'
      src={showData?.photoUrl} />
  }

  function renderUserImage() {
    const supplierNo = showData?.farmerSupplierNo
    const userProfileUrl = showData?.photoUrl
    return !isBusy && <UserProfileLogo>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className='farmer-logo-container'>
          {userProfileUrl ? renderImage() : renderDefaultImage()}
        </div>
        <div className='farmer-name-container'>
          <div className='farmer-supplier'>{t('Supplier No. {{supplierNo}}', { supplierNo })}</div>
          <div className='farmer-company-name'>{showData?.name}</div>
        </div>
      </div>
    </UserProfileLogo>
  }

  return <Layout
    isBusy={isBusy}
    segmented
    close={() => navigate(-1)}
    title={t('Profile user')}
  >
    {renderUserImage()}
    {showData && renderProfileDetails()}
  </Layout>
}
export default Show